module.exports = __webpack_public_path__ + "img/ic_dashboard_medal_gold.f9343e1a.svg";